const BAD_KEYS = ["__proto__", "constructor", "prototype"];

export function sanitizeObject(obj: any): any {
  if (!obj || typeof obj !== "object") return obj;

  Object.keys(obj).forEach((key) => {
    if (BAD_KEYS.includes(key)) {
      delete obj[key];
      return;
    }

    const value = obj[key];
    // protect nested constructor/prototype chains
    if (value && typeof value === "object") {
      BAD_KEYS.forEach((bad) => {
        if (bad in value) {
          delete value[bad];
        }
      });
      sanitizeObject(value);
    }
  });
  return obj;
}
